import { render } from "./RegistrationView.vue?vue&type=template&id=605d10e5&scoped=true"
import script from "./RegistrationView.vue?vue&type=script&lang=js"
export * from "./RegistrationView.vue?vue&type=script&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=605d10e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605d10e5"]])

export default __exports__